import React from "react";
import PropTypes from "prop-types";

import * as types from "../../../constants/ComponentConstants";

import Form from "../../common/Form";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import LinkInput from "../../common/LinkInput";
import LinkInputWithPNG from "../../common/LinkInputWithPNG";
import InstagramLogo from "../../../images/instagramLogo.png";
import YoutubeLogo from "../../../images/youTubeLogo.png";

const SocialeMediaForm = (props) => {
    const {
        model,
        originalModel,
        onChange,
        onSave,
        errors,
        validationMessageType,
        disabled,
        facebookHasFocus
    } = props;

    return (
        <Section title="Sociale media" color={types.COLOR_PURPLE}>
            <Fieldset>
                <Form name="sociale media"
                    headerVisible={false}
                    isNotRequired
                    rightButtonLabel="Bewaar"
                    onRightButtonClick={onSave}
                    rightButtonDisabled={disabled}
                >
                    <LinkInput
                        name="facebookLink"
                        label="Facebook"
                        value={model.facebookLink}
                        originalValue={originalModel.facebookLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['facebookLink'] : ""}
                        validationMessageType={validationMessageType}
                        disabled={disabled}
                        size={12}
                        optional
                        inputmask="https://www.facebook.com/"
                        faIconClassname="fa-facebook c-facebook"
                        hasFocus={facebookHasFocus}
                    />
                    <LinkInput
                        name="linkedInLink"
                        label="LinkedIn"
                        value={model.linkedInLink}
                        originalValue={originalModel.linkedInLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['linkedInLink'] : ""}
                        validationMessageType={validationMessageType}
                        disabled={disabled}
                        size={12}
                        optional
                        inputmask="https://www.linkedin.com/"
                        faIconClassname="fa-linkedin c-linkedin"
                    />
                    <LinkInputWithPNG
                        name="instagramLink"
                        label="Instagram"
                        value={model.instagramLink}
                        originalValue={originalModel.instagramLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['instagramLink'] : ""}
                        validationMessageType={validationMessageType}
                        size={12}
                        optional
                        inputmask="https://www.instagram.com/"
                        iconSrc={InstagramLogo}
                        iconHeight={15}
                    />
                    <LinkInputWithPNG
                        name="youTubeLink"
                        label="Youtube"
                        value={model.youTubeLink}
                        originalValue={originalModel.youTubeLink}
                        onChange={onChange}
                        validationMessage={errors ? errors['youTubeLink'] : ""}
                        validationMessageType={validationMessageType}
                        size={12}
                        optional
                        inputmask="https://www.youtube.com/"
                        iconSrc={YoutubeLogo}
                        iconHeight={13}
                    />
                </Form>
            </Fieldset>
        </Section>
    );
};

SocialeMediaForm.propTypes = {
    model: PropTypes.object,
    originalModel: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    disabled: PropTypes.bool,
    facebookHasFocus: PropTypes.bool
};

export default SocialeMediaForm;